import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.initialiseTooltips();
    this.initialiseDropdowns();
  }

  initialiseTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  initialiseDropdowns() {
    $('[data-toggle="dropdown"]').dropdown();
  }
}
